import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import printer from "@/assets/icons/printer.svg";
import GradientIconButton from "@/components/buttons/GradientIconButton.vue";



export default /*@__PURE__*/_defineComponent({
  __name: 'PrintButton',
  props: {
    btnClasses: {},
    iconClasses: {}
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {



const emits = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(GradientIconButton, {
    btnClasses: __props.btnClasses,
    iconClasses: __props.iconClasses,
    iconSrc: _unref(printer),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('click')))
  }, null, 8, ["btnClasses", "iconClasses", "iconSrc"]))
}
}

})